/*
 * @Author: Json Chen
 * @Date: 2021-07-14 09:26:40
 * @LastEditTime: 2021-07-14 09:28:02
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/CourierAccount/images/index.tsx
 */
import { IMAGE_URL } from 'src/tools/constant';

const SF = `${IMAGE_URL}icon/SF.svg`;
const ZTO = `${IMAGE_URL}icon/ZTO.svg`;
const LabelA4 = `${IMAGE_URL}icon/label-A4.svg`;
const LabelThermal = `${IMAGE_URL}icon/label-thermal.svg`;

export { SF, ZTO, LabelA4, LabelThermal };
